export const BillingTypes = {
    DirectBilled: 2,
    PayrollDeducted: 1
}

export const FormErrors = {
    PaymentError: 'There was an error while processing your payment.',
    VerificationTimeOut: 'Verification time has expired. Please try verifying your identity again.',
    InvalidToken: 'The verification code does not match, please try again.',
    GenericError: 'There was an error while processing your request. Please try again later.',
    TurnstileError: 'Verification failed. Please try again.',
    EnrollmentExpired: 'The enrollment process has expired.',
    CancellationSubmitted: 'Cancellation has been requested. The plan is not canceled yet and requires HR review.'
}

export const ResponseErrors = {
    Application: 'Application',
    InvalidToken: 'Invalid Token',
    Payment: 'Payment',
    UserAccess: 'UserAccess'
}